import { createTheme } from "@mui/material/styles";

export const menuTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#5DCAA5",
      contrastText: "#04342C"
    },
    secondary: {
      main: "#85B7EB"
    },
    background: {
      default: "#1e2229",
      paper: "#282c34"
    },
    text: {
      primary: "#e2e8f0",
      secondary: "#94a3b8"
    },
    divider: "#404754",
    action: {
      active: "#e2e8f0",
      hover: "rgba(226, 232, 240, 0.08)"
    }
  },
  typography: {
    fontFamily: "'Noto Sans', 'Noto Sans SC', sans-serif"
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          backgroundImage: "none",
          "&::before": {
            display: "none"
          },
          borderBottom: "1px solid #404754"
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          minHeight: 48,
          "&.Mui-expanded": {
            minHeight: 48
          }
        },
        content: {
          margin: "10px 0",
          "&.Mui-expanded": {
            margin: "10px 0"
          }
        },
        expandIconWrapper: {
          color: "#94a3b8"
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: "#e2e8f0",
          fontSize: 14
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#64748b",
          "&.Mui-checked": {
            color: "#5DCAA5"
          }
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        rail: {
          opacity: 0.4
        },
        markLabel: {
          color: "#94a3b8"
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          color: "#e2e8f0",
          "&::before": {
            borderBottomColor: "#404754"
          },
          "&:hover:not(.Mui-disabled)::before": {
            borderBottomColor: "#64748b"
          },
          "&::after": {
            borderBottomColor: "#5DCAA5"
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderColor: "#404754",
          color: "#e2e8f0",
          "&:hover": {
            borderColor: "#64748b",
            backgroundColor: "rgba(226, 232, 240, 0.06)"
          }
        }
      }
    },
    MuiButtonGroup: {
      styleOverrides: {
        grouped: {
          borderColor: "#404754 !important"
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#e2e8f0"
        }
      }
    }
  }
});

export const menuColors = {
  text: "#e2e8f0",
  textMuted: "#94a3b8",
  border: "#404754",
  surface: "#282c34",
  surfaceRaised: "#2c3139",
  accent: "#5DCAA5"
};
